/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Stat_SetsInputs */

const en_us2_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sets`)
};

const pt_br2_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries`)
};

const es_419_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`series`)
};

const pt_pt2_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries`)
};

const fr_fr2_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`séries`)
};

const de_de2_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sätze`)
};

const it_it2_search_stat_sets = /** @type {(inputs: Search_Stat_SetsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`serie`)
};

/**
* | output |
* | --- |
* | "sets" |
*
* @param {Search_Stat_SetsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_stat_sets = /** @type {((inputs?: Search_Stat_SetsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Stat_SetsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_stat_sets(inputs)
	if (locale === "es-419") return es_419_search_stat_sets(inputs)
	if (locale === "pt-PT") return pt_pt2_search_stat_sets(inputs)
	if (locale === "fr-FR") return fr_fr2_search_stat_sets(inputs)
	if (locale === "de-DE") return de_de2_search_stat_sets(inputs)
	if (locale === "it-IT") return it_it2_search_stat_sets(inputs)
	return en_us2_search_stat_sets(inputs)
});
export { search_stat_sets as "search.stat_sets" }